import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1032cfba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "matching-status"
}
const _hoisted_2 = {
  key: 1,
  class: "matching-status"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The game couldn't be loaded.", -1))
const _hoisted_4 = { class: "game-bar" }
const _hoisted_5 = { class: "game-title" }
const _hoisted_6 = {
  key: 0,
  class: "game-subtitle"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "team-label" }, "Team", -1))
const _hoisted_12 = { class: "team-name" }
const _hoisted_13 = { class: "team-score-wrap" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "team-pairs"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "pair-card" }
const _hoisted_18 = { class: "pair-name" }
const _hoisted_19 = { class: "board-area" }
const _hoisted_20 = {
  key: 0,
  class: "end-scoreboard"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "final-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "final-label" }, "Final")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "corner" }, null, -1))
const _hoisted_23 = { class: "row-label" }
const _hoisted_24 = ["data-key", "onClick"]
const _hoisted_25 = { class: "card-inner" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-back" }, null, -1))
const _hoisted_27 = { class: "card-front" }
const _hoisted_28 = {
  key: 0,
  class: "card-image"
}
const _hoisted_29 = ["src", "alt"]
const _hoisted_30 = {
  key: 1,
  class: "card-info"
}
const _hoisted_31 = { class: "card-name" }
const _hoisted_32 = { class: "card-info-middle" }
const _hoisted_33 = { class: "card-text" }
const _hoisted_34 = {
  key: 0,
  class: "card-flip-name"
}
const _hoisted_35 = {
  key: 1,
  class: "reveal"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["src"]

import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { EyeIcon, MaximizeIcon, MinimizeIcon, SkipForwardIcon, Volume2Icon, VolumeXIcon, ZapIcon } from '@zhuowenli/vue-feather-icons'
import { useFeatureStore, MatchingGameFeature } from '@/rd/FeatureStore'
import LoadingIndicator from '@/util/LoadingIndicator.vue'
import { MatchingCardPair, MatchingGameImage, MatchingGameDetail } from './MatchingGameDefinition'
import { useGamesApi, GameCardInfo, GameCardImage, GameCardDetail } from '../GamesApi'
import { vFocal, Focal } from '../vFocal'
import MatchingDetailCard from './MatchingDetailCard.vue'
import MatchingGameSetup from './MatchingGameSetup.vue'
import MatchingConfetti from './MatchingConfetti.vue'
import MatchingImageCard from './MatchingImageCard.vue'
import confetti from 'canvas-confetti'
import * as sounds from './GameSounds'
const DemoMemoryGameId = '25TWG3'
const flipBackDelayMs = 10000
const turnSwitchDelayMs = 500 // pause after the cards flip back before the turn passes
const turnBarSlideMs = 900 // turn bar transition time; board stays locked until it lands
const uiScaleReferenceWidth = 1440 // play-area width (px) at which the chrome is drawn at 1x
const dealWaitMs = 1800 // 39 cards × 28ms stagger + 400ms animation + ~300ms pause before spin
const detailHeightFraction = 0.85 // detail card height as a share of the viewport (consistent across window/fullscreen)
const maxAspect = 16 / 9 // cap the play area + reveal width to 16:9 on ultra-wide screens
const detailWidthFactor = 1.15
const detailHeightFactor = 1.6 // detail card height relative to the primary image (i.e. imageSize)
const secondaryFactor = 0.4
const revealOverlapFactor = 0.03 // image/detail/secondary cards overlap slightly
const detailCentreBias = 0.05 // detail card centred slightly right of page centre
const stackItemSize = 84
const turnBarWidth = 72
const floatAnimMs = 600
const circleInset = 4 // swatch offset above the team circle

type CardFace = 'image' | 'info'
type Phase = 'idle' | 'celebrate' | 'collecting'

interface PlayCard {
  key: number
  pairId: string
  face: CardFace
  pair: MatchingCardPair
}

interface SecondaryImage {
  image: MatchingGameImage
  w: number // resting square side
  dw: number // displayed width (grows to the image's natural ratio when focused)
  dh: number
  restTransform: string
  transform: string
}

const bypassFeatureGate = true
const maxBoardRows = 4

export default /*#__PURE__*/_defineComponent({
  __name: 'MatchingGame',
  props: {
    gameId: {}
  },
  setup(__props: any) {

const props = __props;

const { mutedRef } = sounds

// Shown when an image is "focused" to full view: default centred cover (no custom framing).
const DEFAULT_FOCAL: Focal = { focusX: 0.5, focusY: 0.5, zoom: 1 }



const router = useRouter()
const featureStore = useFeatureStore()
const gamesApi = useGamesApi()

const rootRef = ref<HTMLElement>()
const boardRef = ref<HTMLElement>()
const playAreaRef = ref<HTMLElement>()
const isFullscreenRef = ref(false)
const alignTopRef = ref(0)
const teamCentersRef = ref<number[]>([])
const turnBarTopRef = ref(0)
const gridGapRef = ref(8)
const gridCardSizeRef = ref(0)
const boardMaxWidthRef = ref<number>()
const uiScaleRef = ref(1) // chrome scale factor, driven off the viewport so it grows in fullscreen
const endGameRef = ref(false)
let mismatchTimer = 0
let peekTimer = 0

const loadingRef = ref(false)
const errorRef = ref(false)

const cardPairsRef = ref<MatchingCardPair[]>([])
const deckRef = ref<PlayCard[]>([])
const flippedKeysRef = ref<number[]>([])
const peekingRef = ref(false)
const matchedPairIdsRef = ref(new Set<string>())
const collectedKeysRef = ref<number[]>([])
const lockRef = ref(false)

// team play
const currentTeamRef = ref(0)
const teamMatchesRef = ref<MatchingCardPair[][]>([[], []])

// turn bar: normally follows the current team; the "who goes first" spin overrides it
const turnBarOverrideRef = ref<number | null>(null)
const turnBarVisibleRef = ref(false)
const turnBarTransitionRef = ref('transform 0.9s ease-in-out')
const turnBarXRef = computed(() => turnBarOverrideRef.value ?? teamCentersRef.value[currentTeamRef.value] ?? 0)

// teams whose score is mid-celebration (drives the score bump animation)
const scoreBumpTeamsRef = ref<number[]>([])

// team colour + name picker
const teamColorsRef = ref(['#000000', '#ffffff'])
const teamNamesRef = ref(['Charcoal', 'Cotton ball'])
// The setup preview highlights the nearest paternal card: the shortest relationship path
// ending in "F" (father). Falls back to the first pair when none end in "F".
const firstCardPairRef = computed(() => {
  const pairs = cardPairsRef.value as MatchingCardPair[]
  const nearestFather = pairs
    .filter(p => (p.relationship || '').endsWith('F'))
    .reduce<MatchingCardPair | undefined>(
      (best, p) => (!best || p.relationship.length < best.relationship.length ? p : best),
      undefined)
  return nearestFather ?? pairs[0]
})
const firstImageSrcRef = computed(() => imageSrc(firstCardPairRef.value?.images?.[0]))
const setupDoneRef = ref(false)
const dealReadyRef = ref(false)
const gameTitleRef = ref('')
const gameSubtitleRef = ref('')

// match reveal
const phaseRef = ref<Phase>('idle')
const revealPairRef = ref<MatchingCardPair>()
const revealImageRef = ref<MatchingGameImage>()
// The primary reveal image's live focal. Focusing to full view keeps the stored focus point and
// only eases zoom -> 1 (over the same duration as the box grow), so the framing doesn't jump.
const revealFocalRef = ref<Focal>(DEFAULT_FOCAL)
let revealZoomRaf = 0
const revealSecondaryRef = ref<SecondaryImage[]>([])
const imageBoxRef = ref({ w: 0, h: 0 })
const detailBoxRef = ref({ w: 0, h: 0 })
const imageTransformRef = ref('')
const detailTransformRef = ref('')
const revealVisibleRef = ref(false)
const revealImageSizeRef = ref(0)
const imageRestRef = ref('')
const focusKeyRef = ref<string | null>(null)
const celebratingKeysRef = ref<number[]>([])
const stackEls: Record<number, HTMLElement | null> = {}

// re-opening a collected pair from a team stack (read-only review, no scoring)
const reviewModeRef = ref(false)
let reviewOriginEl: HTMLElement | null = null

// TODO restore feature gating once the RD 'MemoryGame' feature is declared server-side
const featureEnabledRef = computed(() =>
  bypassFeatureGate ? true : featureStore.isFeatureEnabled(MatchingGameFeature))
const gameId = computed(() => props.gameId || DemoMemoryGameId)

// Board shape from the card count: the factor pair closest to square that stays landscape
// (cols > rows) and fills every cell -- rows = largest divisor with n / rows > rows -- but never
// more than 4 rows. Past that the board spreads into wider rows and the last row may fall short,
// centered by cardColumnStart. E.g. 20 -> 5x4, 24 -> 6x4, 28 -> 7x4, 30 -> 8x4 (last row of 6).
const columnCountRef = computed(() => {
  const n = deckRef.value.length
  if (n === 0) {
    return 1
  }
  let rows = Math.floor(Math.sqrt(n))
  while (rows > 1 && (n % rows !== 0 || n / rows <= rows)) {
    rows--
  }
  rows = Math.min(rows, maxBoardRows)
  return Math.ceil(n / rows)
})
// A short final row is centered by shifting its cards right past the empty columns.
// Grid column 1 is the row-label, so card columns start at 2.
function cardColumnStart(row: PlayCard[], cardIndex: number) {
  const offset = Math.floor((columnCountRef.value - row.length) / 2)
  return 2 + offset + cardIndex
}
const columnLabelsRef = computed(() =>
  Array.from({ length: columnCountRef.value }, (_, i) => String.fromCharCode(65 + i)))
const rowsRef = computed(() => {
  const cols = columnCountRef.value
  const rows: PlayCard[][] = []
  for (let i = 0; i < deckRef.value.length; i += cols) {
    rows.push(deckRef.value.slice(i, i + cols))
  }
  return rows
})

// grid coordinates (row index + CSS grid column) per card key, so we can tell when two picks are
// orthogonally adjacent. Grid column reflects the centring offset of a short final row, so cards
// that don't share a column aren't treated as vertically adjacent.
const cardGridPosRef = computed(() => {
  const map: Record<number, { r: number; col: number }> = {}
  rowsRef.value.forEach((row, r) => {
    row.forEach((card, ci) => { map[card.key] = { r, col: cardColumnStart(row, ci) } })
  })
  return map
})

// per-card slide (px) that pushes two orthogonally-adjacent picks apart so their zoomed boxes don't
// overlap on a shared side. A lone pick, or diagonally-adjacent picks (corner overlap is fine), get
// no nudge. Consumed as --nudge-x/--nudge-y by the .card.selected transform.
const selectionNudgeRef = ref<Record<number, { x: number; y: number }>>({})

watch([flippedKeysRef, gridCardSizeRef], ([keys]) => {
  const nudge: Record<number, { x: number; y: number }> = {}
  if (keys.length === 2) {
    const pos = cardGridPosRef.value
    const a = pos[keys[0]]
    const b = pos[keys[1]]
    // at scale 1.5, adjacent cards (~1.09 card-widths between centres) overlap by ~0.41 of a card.
    // 0.25 card-width per side clears the overlap down to exactly the normal grid gap; the extra
    // 0.25 grid-gap per side widens that to ~1.5x the normal gap. Keep in sync with scale(1.5).
    const shift = 0.25 * gridCardSizeRef.value + 0.25 * gridGapRef.value
    if (a && b && a.r === b.r && Math.abs(a.col - b.col) === 1) {
      const leftFirst = a.col < b.col
      nudge[leftFirst ? keys[0] : keys[1]] = { x: -shift, y: 0 }
      nudge[leftFirst ? keys[1] : keys[0]] = { x: shift, y: 0 }
    } else if (a && b && a.col === b.col && Math.abs(a.r - b.r) === 1) {
      const topFirst = a.r < b.r
      nudge[topFirst ? keys[0] : keys[1]] = { x: 0, y: -shift }
      nudge[topFirst ? keys[1] : keys[0]] = { x: 0, y: shift }
    }
  }
  selectionNudgeRef.value = nudge
})

const teamsRef = computed(() => [
  { id: 0, side: 'left', token: 'black', matches: teamMatchesRef.value[0] },
  { id: 1, side: 'right', token: 'white', matches: teamMatchesRef.value[1] },
])

const collectedCountRef = computed(() =>
  teamMatchesRef.value[0].length + teamMatchesRef.value[1].length)
const wonRef = computed(() =>
  cardPairsRef.value.length > 0 && collectedCountRef.value === cardPairsRef.value.length)
// the winning team id, or null on a tie
const winnerTeamRef = computed(() => {
  const a = teamMatchesRef.value[0].length
  const b = teamMatchesRef.value[1].length
  if (a === b) {
    return null
  }
  return a > b ? 0 : 1
})

// hint: blink an orange outline on 2 randomly chosen unmatched pairs
const hintPairIdsRef = ref<string[]>([])
const hintBlinkingRef = ref(false)
let hintTimer: number | undefined
const remainingPairCountRef = computed(() => cardPairsRef.value.length - matchedPairIdsRef.value.size)

function showHint() {
  hintPairIdsRef.value = hintPairIdsRef.value.filter(id => !matchedPairIdsRef.value.has(id))
  const need = 2 - hintPairIdsRef.value.length
  if (need > 0) {
    const existing = new Set(hintPairIdsRef.value)
    const remaining = cardPairsRef.value.filter(p => !matchedPairIdsRef.value.has(p.id) && !existing.has(p.id))
    const shuffled = [...remaining].sort(() => Math.random() - 0.5)
    hintPairIdsRef.value = [...hintPairIdsRef.value, ...shuffled.slice(0, need).map(p => p.id)]
  }
  hintBlinkingRef.value = false
  window.clearTimeout(hintTimer)
  requestAnimationFrame(() => {
    hintBlinkingRef.value = true
    hintTimer = window.setTimeout(() => { hintBlinkingRef.value = false }, 1600)
  })
}

// reset hint pairs when the turn switches so the next player gets a fresh selection
watch(currentTeamRef, () => { hintPairIdsRef.value = [] })

// celebrate the winner with confetti from their side once the final view has settled
watch(endGameRef, (ended) => {
  const winner = winnerTeamRef.value
  if (!ended || winner === null) {
    return
  }
  sounds.gameOver()
  window.setTimeout(() => {
    const circle = document.querySelectorAll<HTMLElement>('.team-circle')[winner]
    if (!circle) {
      return
    }
    const r = circle.getBoundingClientRect()
    const origin = { x: (r.left + r.width / 2) / window.innerWidth, y: (r.top + r.height / 2) / window.innerHeight }
    const colors = [teamColorsRef.value[winner], '#f7810a', '#ffd400', '#39b54a', '#2e9bd6', '#e23b6d']
    confetti({ particleCount: 120, spread: 90, startVelocity: 45, origin, colors })
    confetti({ particleCount: 80, spread: 120, startVelocity: 30, origin, colors, scalar: 0.9 })
  }, 600) // let the team panels finish expanding first
})

// gate on the feature flag: unknown while loading, redirect away when disabled, load when enabled
watch(featureEnabledRef, (enabled) => {
  if (enabled === false) {
    router.replace('/games')
  } else if (enabled === true && cardPairsRef.value.length === 0 && !loadingRef.value) {
    loadDefinition()
  }
}, { immediate: true })

watch(() => deckRef.value.length, () => requestAnimationFrame(measureAlignment))

async function loadDefinition() {
  loadingRef.value = true
  errorRef.value = false
  try {
    // Data comes through the games API (like the designer); listCardInfo returns every card in one
    // call. Images are served straight from the public blob container -- see imageSrc.
    const [definition, cards] = await Promise.all([
      gamesApi.getDefinition(gameId.value),
      gamesApi.listCardInfo(gameId.value),
    ])
    if (!definition || cards.length === 0) {
      throw new Error('Game not found.')
    }
    cardPairsRef.value = cards.map(toCardPair)
    gameTitleRef.value = definition.title ?? 'Memory Game'
    gameSubtitleRef.value = definition.subtitle ?? ''
    setupDoneRef.value = false
    resetGame()
    // warm the browser cache now, during setup, while the player is choosing teams -- so board cards
    // and (especially) the match-reveal secondary images are already decoded when they're shown
    preloadImages()
  } catch {
    errorRef.value = true
  } finally {
    loadingRef.value = false
  }
}

// Map a normalized GameCardInfo (new data format) to the player's internal card-pair model, so the
// rest of the game -- deck, reveal, detail/image cards -- is unchanged.
function toCardPair(card: GameCardInfo): MatchingCardPair {
  return {
    id: card.id,
    name: card.name ?? '',
    text: card.text ?? '',
    relationship: card.relationship ?? '',
    flag: card.flag,
    notes: card.notes,
    childOrder: card.childOrder,
    siblingsCount: card.siblingsCount,
    childCount: card.childCount,
    images: (card.images ?? []).map(toImage),
    details: card.details?.map(toDetail),
  }
}

// Healed images live at images/{imageId}.jpg; a ported image not yet healed keeps its legacy path.
// Either way imageSrc resolves it against the game folder, so downstream code needs no change.
function toImage(image: GameCardImage): MatchingGameImage {
  return {
    path: image.path ?? `images/${image.imageId}.jpg`,
    focusX: image.focusX ?? 0.5,
    focusY: image.focusY ?? 0.5,
    zoom: image.zoom ?? 1,
  }
}

// The new model has no per-detail spouse (it's folded into value); the detail card handles its
// absence. Per-detail flag is carried through.
function toDetail(detail: GameCardDetail): MatchingGameDetail {
  return {
    date: detail.date ?? '',
    type: detail.type,
    value: detail.value,
    place: detail.place,
    flag: detail.flag,
    highlight: detail.highlight,
  }
}

function resetGame() {
  window.removeEventListener('click', onMismatchClick, true)
  window.clearTimeout(mismatchTimer)
  window.clearTimeout(hintTimer)
  window.clearTimeout(peekTimer)
  hintPairIdsRef.value = []
  hintBlinkingRef.value = false
  peekingRef.value = false
  endGameRef.value = false
  dealReadyRef.value = setupDoneRef.value // Play Again: cards appear immediately; first game: startGame controls timing
  const cards: PlayCard[] = []
  let key = 0
  for (const pair of cardPairsRef.value) {
    cards.push({ key: key++, pairId: pair.id, face: 'image', pair })
    cards.push({ key: key++, pairId: pair.id, face: 'info', pair })
  }
  deckRef.value = shuffle(cards)
  flippedKeysRef.value = []
  matchedPairIdsRef.value = new Set<string>()
  collectedKeysRef.value = []
  currentTeamRef.value = 0
  teamMatchesRef.value = [[], []]
  phaseRef.value = 'idle'
  clearReveal()
  lockRef.value = false
  // reset the turn bar; if we're restarting mid-play (Play again), re-run the who-goes-first spin
  turnBarOverrideRef.value = null
  turnBarTransitionRef.value = 'transform 0.9s ease-in-out'
  turnBarVisibleRef.value = false
  if (setupDoneRef.value) {
    sounds.placeCards() // startGame cues this on the first deal -- Play again re-deals here
    requestAnimationFrame(() => requestAnimationFrame(() => {
      measureAlignment()
      spinTurnBar()
    }))
  }
}

function shuffle<T>(items: T[]) {
  for (let i = items.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    const temp = items[i]
    items[i] = items[j]
    items[j] = temp
  }
  return items
}

function isMatched(card: PlayCard) {
  return matchedPairIdsRef.value.has(card.pairId)
}

function isFaceUp(card: PlayCard) {
  return peekingRef.value || isMatched(card) || flippedKeysRef.value.includes(card.key)
}

// a card the player has picked this turn: face-up by choice and not yet collected into a match.
// These zoom up (and slide apart when adjacent) via the .selected class + --nudge-x/-y.
function isSelected(card: PlayCard) {
  return flippedKeysRef.value.includes(card.key) && !collectedKeysRef.value.includes(card.key)
}

// peek: flip every card face-up for a moment, then flip them all back
function peek() {
  if (peekingRef.value || lockRef.value || phaseRef.value !== 'idle') {
    return
  }
  peekingRef.value = true
  sounds.cardReveal()
  peekTimer = window.setTimeout(() => {
    sounds.cardHide()
    peekingRef.value = false
  }, 2000)
}

// give every remaining pair to the current team, then jump to the end screen
function skipToEnd() {
  if (endGameRef.value) {
    return
  }
  window.removeEventListener('click', onMismatchClick, true)
  window.clearTimeout(mismatchTimer)
  window.clearTimeout(hintTimer)
  window.clearTimeout(peekTimer)
  hintPairIdsRef.value = []
  hintBlinkingRef.value = false
  peekingRef.value = false
  flippedKeysRef.value = []
  lockRef.value = false
  const teamId = currentTeamRef.value
  const unclaimed = cardPairsRef.value.filter(pair => !matchedPairIdsRef.value.has(pair.id))
  matchedPairIdsRef.value = new Set(cardPairsRef.value.map(pair => pair.id))
  teamMatchesRef.value = teamMatchesRef.value.map((matches, id) =>
    id === teamId ? [...matches, ...unclaimed] : matches)
  endGameRef.value = true
}

function flip(card: PlayCard) {
  if (phaseRef.value !== 'idle' || lockRef.value) {
    return
  }
  if (isFaceUp(card) || flippedKeysRef.value.length === 2) {
    return
  }
  sounds.cardReveal()
  flippedKeysRef.value = [...flippedKeysRef.value, card.key]
  if (flippedKeysRef.value.length === 2) {
    resolveFlipped()
  }
}

function resolveFlipped() {
  const [firstKey, secondKey] = flippedKeysRef.value
  const first = deckRef.value.find(c => c.key === firstKey)
  const second = deckRef.value.find(c => c.key === secondKey)
  if (first && second && first.pairId === second.pairId) {
    sounds.matchSucceed()
    matchedPairIdsRef.value = new Set(matchedPairIdsRef.value).add(first.pairId)
    const imageCard = first.face === 'image' ? first : second
    const infoCard = first.face === 'info' ? first : second
    startCelebrate(imageCard, infoCard)
  } else {
    lockRef.value = true
    //window.setTimeout(() => sounds.matchFail(), 400) // after the 0.4s flip transition completes
    mismatchTimer = window.setTimeout(resolveMismatch, flipBackDelayMs)
    // a click flips the mismatched cards back right away
    requestAnimationFrame(() => window.addEventListener('click', onMismatchClick, true))
  }
}

function onMismatchClick(event: MouseEvent) {
  event.preventDefault()
  event.stopPropagation()
  window.clearTimeout(mismatchTimer)
  resolveMismatch()
}

function resolveMismatch() {
  window.removeEventListener('click', onMismatchClick, true)
  const [firstKey] = flippedKeysRef.value
  // flip cards back one at a time with a sound each
  sounds.cardHide()
  flippedKeysRef.value = flippedKeysRef.value.filter(k => k !== firstKey)
  setTimeout(() => {
    sounds.cardHide()
    flippedKeysRef.value = []
    // keep the board locked through the hand-off: then the turn bar slides across
    setTimeout(() => {
      const nextTeam = 1 - currentTeamRef.value
      currentTeamRef.value = nextTeam
      setTimeout(() => {
        sounds.turnLanded(nextTeam)
        lockRef.value = false
      }, turnBarSlideMs)
    }, turnSwitchDelayMs)
  }, 200)
}

function cardEl(key: number) {
  return boardRef.value?.querySelector<HTMLElement>(`[data-key="${key}"]`) ?? null
}

// lay out the reveal composition (image + detail + secondaries) at their resting positions
function composeReveal(pair: MatchingCardPair) {
  // anchor the whole reveal on viewport height so the detail card is a consistent share of the page
  let imageSize = (window.innerHeight * detailHeightFraction) / detailHeightFactor
  let detailW = imageSize * detailWidthFactor
  let secW = imageSize * secondaryFactor
  // keep the image + detail + secondary composition within the (16:9-capped) page width
  const pageWidth = Math.min(window.innerWidth, window.innerHeight * maxAspect)
  const compositionW = imageSize + detailW + secW
  const maxCompositionW = pageWidth * 0.95
  if (compositionW > maxCompositionW) {
    const shrink = maxCompositionW / compositionW
    imageSize *= shrink
    detailW *= shrink
    secW *= shrink
  }
  const detailH = imageSize * detailHeightFactor
  const overlap = imageSize * revealOverlapFactor
  const secondaries = pair.images.slice(1)

  const centreY = window.innerHeight / 2
  // detail card is the anchor: centred vertically, slightly right of page centre
  const detailX = window.innerWidth * (0.5 + detailCentreBias) - detailW / 2
  const detailTop = centreY - detailH / 2
  // primary image overlaps the detail on the left, near its top
  const imageX = detailX - imageSize + overlap
  const imageTop = detailTop + imageSize * 0.15
  // secondary images overlap the detail on the right, top-aligned with the primary image
  const secX = detailX + detailW - overlap
  const secStep = secW * 0.7 // stack the secondaries with a 30% overlap
  const columnTop = imageTop

  const imageRest = `translate(${imageX}px, ${imageTop}px) scale(1)`
  const detailRest = `translate(${detailX}px, ${detailTop}px) scale(1)`

  imageBoxRef.value = { w: imageSize, h: imageSize }
  detailBoxRef.value = { w: detailW, h: detailH }
  revealImageSizeRef.value = imageSize
  imageRestRef.value = imageRest
  focusKeyRef.value = null
  revealPairRef.value = pair
  revealImageRef.value = pair.images[0]
  setRevealFocal(pair.images[0])
  revealSecondaryRef.value = secondaries.map((image, i) => {
    const rest = `translate(${secX}px, ${columnTop + i * secStep}px) scale(1)`
    return { image, w: secW, dw: secW, dh: secW, restTransform: rest, transform: rest }
  })
  revealVisibleRef.value = false
  return { imageRest, detailRest, imageSize, detailW }
}

// the matched pair lifts out at full size (crisp): image card + detail card float from the grid slots
function startCelebrate(imageCard: PlayCard, infoCard: PlayCard) {
  const imageRect = cardEl(imageCard.key)?.getBoundingClientRect()
  const infoRect = cardEl(infoCard.key)?.getBoundingClientRect()
  if (!imageRect || !infoRect) {
    return
  }
  const { imageRest, detailRest, imageSize, detailW } = composeReveal(imageCard.pair)
  reviewModeRef.value = false
  imageTransformRef.value = `translate(${imageRect.left}px, ${imageRect.top}px) scale(${imageRect.width / imageSize})`
  detailTransformRef.value = `translate(${infoRect.left}px, ${infoRect.top}px) scale(${infoRect.width / detailW})`

  collectedKeysRef.value = [...collectedKeysRef.value, imageCard.key, infoCard.key]
  celebratingKeysRef.value = [imageCard.key, infoCard.key]
  phaseRef.value = 'celebrate'
  lockRef.value = true

  // start at the grid slots, then animate to the composition
  requestAnimationFrame(() => requestAnimationFrame(() => {
    imageTransformRef.value = imageRest
    detailTransformRef.value = detailRest
    revealVisibleRef.value = true
  }))
}

// tapping a collected pair in a team's stack re-opens its reveal (read-only, no scoring)
function reviewMatch(pair: MatchingCardPair, event: MouseEvent) {
  if (phaseRef.value !== 'idle') {
    return
  }
  reviewOriginEl = event.currentTarget as HTMLElement
  const originRect = reviewOriginEl.getBoundingClientRect()
  const { imageRest, detailRest, imageSize } = composeReveal(pair)
  reviewModeRef.value = true
  // the image flies up from the stack thumbnail; the detail + secondaries fade in
  imageTransformRef.value = `translate(${originRect.left}px, ${originRect.top}px) scale(${originRect.width / imageSize})`
  detailTransformRef.value = detailRest
  phaseRef.value = 'celebrate'

  requestAnimationFrame(() => requestAnimationFrame(() => {
    imageTransformRef.value = imageRest
    revealVisibleRef.value = true
  }))
}

// close a review: fly the image back to its stack thumbnail, fade the rest, then clear
function closeReview() {
  focusKeyRef.value = null
  revealVisibleRef.value = false
  const size = revealImageSizeRef.value
  imageBoxRef.value = { w: size, h: size }
  const originRect = reviewOriginEl?.getBoundingClientRect()
  if (originRect && size) {
    imageTransformRef.value = `translate(${originRect.left}px, ${originRect.top}px) scale(${originRect.width / size})`
  }
  window.setTimeout(() => {
    reviewModeRef.value = false
    phaseRef.value = 'idle'
    clearReveal()
  }, floatAnimMs)
}

// tapping off the reveal cards: collect the fresh match, or just close a review
function dismissReveal() {
  if (reviewModeRef.value) {
    closeReview()
  } else {
    collectMatch()
  }
}

// click an image to bring it to the centre showing the whole photo (natural aspect); the rest fades out
// Seed the primary reveal focal to the image's stored framing (the un-focused state).
function setRevealFocal(image?: MatchingGameImage) {
  cancelAnimationFrame(revealZoomRaf)
  revealFocalRef.value = image
    ? { focusX: image.focusX, focusY: image.focusY, zoom: image.zoom }
    : DEFAULT_FOCAL
}

// Ease the primary reveal focal's zoom to a target over the box-grow duration, keeping the focus
// point fixed. At zoom 1 in the (natural-aspect) focused box the whole image shows regardless of
// the focus point, so easing only zoom un-crops smoothly without the centre-snap.
function tweenRevealZoom(targetZoom: number) {
  cancelAnimationFrame(revealZoomRaf)
  const { focusX, focusY, zoom: startZoom } = revealFocalRef.value
  const startTime = performance.now()
  const duration = 600 // matches the .reveal-image transform/size transition
  const step = (now: number) => {
    const t = Math.min(1, (now - startTime) / duration)
    const eased = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2
    revealFocalRef.value = { focusX, focusY, zoom: startZoom + (targetZoom - startZoom) * eased }
    if (t < 1) {
      revealZoomRaf = requestAnimationFrame(step)
    }
  }
  revealZoomRaf = requestAnimationFrame(step)
}

function focusImage(key: string) {
  if (phaseRef.value !== 'celebrate') {
    return
  }
  if (focusKeyRef.value === key) {
    unfocusImage()
    return
  }
  focusKeyRef.value = key
  const box = focusBox(revealImgEl(key))
  const target = centredTransform(box)
  if (key === 'primary') {
    imageBoxRef.value = box
    imageTransformRef.value = target
    tweenRevealZoom(1)
  } else {
    const index = Number(key.slice(4))
    revealSecondaryRef.value = revealSecondaryRef.value.map((s, i) =>
      (i === index ? { ...s, dw: box.w, dh: box.h, transform: target } : s))
  }
}

function unfocusImage() {
  const key = focusKeyRef.value
  focusKeyRef.value = null
  if (key === 'primary') {
    const size = revealImageSizeRef.value
    imageBoxRef.value = { w: size, h: size }
    imageTransformRef.value = imageRestRef.value
    tweenRevealZoom(revealImageRef.value?.zoom ?? 1)
  } else if (key) {
    const index = Number(key.slice(4))
    revealSecondaryRef.value = revealSecondaryRef.value.map((s, i) =>
      (i === index ? { ...s, dw: s.w, dh: s.w, transform: s.restTransform } : s))
  }
}

// a box at 90% page height in the image's own aspect ratio, clamped to the page width
function focusBox(img: HTMLImageElement | null) {
  const ratio = img && img.naturalWidth ? img.naturalWidth / img.naturalHeight : 1
  let h = window.innerHeight * 0.9
  let w = h * ratio
  const maxW = window.innerWidth * 0.92
  if (w > maxW) {
    w = maxW
    h = w / ratio
  }
  return { w, h }
}

function centredTransform(box: { w: number; h: number }) {
  return `translate(${window.innerWidth / 2 - box.w / 2}px, ${window.innerHeight / 2 - box.h / 2}px) scale(1)`
}

function revealImgEl(key: string) {
  if (key === 'primary') {
    return document.querySelector<HTMLImageElement>('.reveal-image img')
  }
  const index = Number(key.slice(4))
  return document.querySelectorAll('.reveal-secondary')[index]?.querySelector('img') ?? null
}

// second click: the detail card and secondary images fade out, only the primary image flies to the team's stack
function collectMatch() {
  if (phaseRef.value !== 'celebrate') {
    return
  }
  phaseRef.value = 'collecting'
  focusKeyRef.value = null
  const imageSize = revealImageSizeRef.value
  // a focused image may have grown to its natural ratio: restore the square box for the fly-to-stack
  imageBoxRef.value = { w: imageSize, h: imageSize }
  revealSecondaryRef.value = revealSecondaryRef.value.map(s => ({ ...s, dw: s.w, dh: s.w, transform: s.restTransform }))
  revealVisibleRef.value = false
  const teamId = currentTeamRef.value
  const slot = nextStackSlot(teamId)
  if (slot && imageSize) {
    const scale = (stackItemSize * uiScaleRef.value) / imageSize
    const half = (imageSize * scale) / 2
    imageTransformRef.value = `translate(${slot.x - half}px, ${slot.y - half}px) scale(${scale})`
  }
  const pair = revealPairRef.value
  setTimeout(() => finishCollect(teamId, pair), floatAnimMs)
}

function nextStackSlot(teamId: number) {
  const stack = stackEls[teamId]
  if (!stack) {
    return null
  }
  const rect = stack.getBoundingClientRect()
  const advance = 59 * uiScaleRef.value // visible height of each overlapped stack card
  const count = teamMatchesRef.value[teamId].length
  return { x: rect.left + rect.width / 2, y: rect.top + advance * count + 42 * uiScaleRef.value }
}

function finishCollect(teamId: number, pair?: MatchingCardPair) {
  if (pair) {
    sounds.matchCollect()
    teamMatchesRef.value = teamMatchesRef.value.map((matches, id) =>
      id === teamId ? [...matches, pair] : matches)
    bumpScore(teamId)
  }
  clearReveal()
  flippedKeysRef.value = []
  phaseRef.value = 'idle'
  lockRef.value = false
  // a correct guess keeps the same team's turn
  if (wonRef.value) {
    setTimeout(() => { endGameRef.value = true }, 500)
  }
}

// restart the score bump animation for a team (remove then re-add so it re-triggers on repeat scores)
function bumpScore(teamId: number) {
  scoreBumpTeamsRef.value = scoreBumpTeamsRef.value.filter(id => id !== teamId)
  requestAnimationFrame(() => {
    scoreBumpTeamsRef.value = [...scoreBumpTeamsRef.value, teamId]
    window.setTimeout(() => {
      scoreBumpTeamsRef.value = scoreBumpTeamsRef.value.filter(id => id !== teamId)
    }, 800)
  })
}

function clearReveal() {
  revealPairRef.value = undefined
  revealImageRef.value = undefined
  revealSecondaryRef.value = []
  celebratingKeysRef.value = []
  revealVisibleRef.value = false
}

function setStackRef(teamId: number, el: unknown) {
  stackEls[teamId] = (el as HTMLElement) ?? null
}

function measureAlignment() {
  // base scale on capped viewport width, not card size, to avoid a panel<->board feedback loop.
  // done before the board/play guard so setup screens also scale in fullscreen.
  const cappedWidth = Math.min(window.innerWidth, window.innerHeight * maxAspect)
  uiScaleRef.value = Math.max(1, cappedWidth / uiScaleReferenceWidth)
  rootRef.value?.style.setProperty('--ui-scale', uiScaleRef.value.toFixed(3))

  const board = boardRef.value
  const play = playAreaRef.value
  if (!board || !play) {
    return
  }
  const playTop = play.getBoundingClientRect().top
  const colLabel = board.querySelector<HTMLElement>('.col-label')
  if (colLabel) {
    // align the team circles with the top of the column labels
    alignTopRef.value = Math.max(0, colLabel.getBoundingClientRect().top - playTop - circleInset)
  }
  const firstCard = board.querySelector<HTMLElement>('.card')
  if (firstCard && firstCard.offsetWidth > 0) {
    // Size the board to fit BOTH the horizontal space (between the team panels) and the height below
    // the play area, so near-square boards don't run off the bottom. Both budgets come from the
    // containers -- not the board's own width -- so capping the board can't feed back into the
    // measurement (offsetWidth here is only a visibility guard, skipped when hidden at end-game).
    const rows = rowsRef.value.length
    const cols = columnCountRef.value
    const areaWidth = (board.parentElement as HTMLElement).getBoundingClientRect().width
    const colLabelH = colLabel?.getBoundingClientRect().height ?? 0
    const rowLabelW = board.querySelector<HTMLElement>('.row-label')?.getBoundingClientRect().width ?? 0
    // each track carries a card plus a ~9% gap, so divide each budget by (count * 1.09)
    const cardByWidth = (areaWidth - rowLabelW) / (cols * 1.09)
    const cardByHeight = (window.innerHeight - playTop - 16 - colLabelH) / (rows * 1.09)
    const cardSize = Math.max(0, Math.min(cardByWidth, cardByHeight))
    gridCardSizeRef.value = cardSize
    gridGapRef.value = Math.round(cardSize * 0.09)
    boardMaxWidthRef.value = Math.floor(rowLabelW + cols * cardSize + cols * gridGapRef.value)
  }
  const indicators = [...play.querySelectorAll<HTMLElement>('.team-indicator')]
  if (indicators.length === 2) {
    teamCentersRef.value = indicators.map(el => {
      const rect = el.getBoundingClientRect()
      return rect.left + rect.width / 2
    })
    turnBarTopRef.value = indicators[0].getBoundingClientRect().top - 18 * uiScaleRef.value
  }
}

// on game start, the turn bar chooses who goes first: appear in the middle, pause, do a few
// short headfakes near the centre, then sweep continuously across to the first team
function spinTurnBar() {
  const centers = teamCentersRef.value
  if (centers.length < 2) {
    return
  }
  const middle = (centers[0] + centers[1]) / 2
  const fakeDist = Math.min(100, (centers[1] - centers[0]) * 0.14) // short nudge, not across the page
  const fakes = 2 + Math.floor(Math.random() * 3) // 2..4 headfakes
  const finalTeam = Math.random() < 0.5 ? 0 : 1
  const targetDir = finalTeam === 0 ? -1 : 1 // direction from the middle toward the first team
  const fakeMs = 260
  const settleMs = 600
  const pauseMs = 550

  // lock the board while the bar decides who goes first
  lockRef.value = true

  // appear in the middle, no motion
  turnBarTransitionRef.value = 'none'
  turnBarOverrideRef.value = middle
  turnBarVisibleRef.value = true

  // short headfakes oscillating around the middle; the last one lands on the side away from the
  // target so the final move is one continuous sweep across, never a stop-then-go same direction
  let t = pauseMs
  for (let i = 0; i < fakes; i++) {
    const dir = -targetDir * ((fakes - 1 - i) % 2 === 0 ? 1 : -1)
    window.setTimeout(() => {
      turnBarTransitionRef.value = `transform ${fakeMs}ms ease-in-out`
      turnBarOverrideRef.value = middle + dir * fakeDist
    }, t)
    t += fakeMs
  }

  // one decisive glide across to the first team
  window.setTimeout(() => {
    turnBarTransitionRef.value = `transform ${settleMs}ms ease-out`
    turnBarOverrideRef.value = centers[finalTeam]
  }, t)
  t += settleMs

  // lock in the first team, restore the slow transition, and hand control to the players
  window.setTimeout(() => {
    turnBarTransitionRef.value = 'transform 0.9s ease-in-out'
    currentTeamRef.value = finalTeam
    turnBarOverrideRef.value = null
    sounds.turnLanded(finalTeam)
    lockRef.value = false
  }, t + 40)
}

function imageSrc(image?: MatchingGameImage) {
  return image ? gamesApi.imagePathUrl(gameId.value, image.path) : ''
}

// Warm the browser cache for every game image while the player is still in setup, so nothing has to
// stream in (and visibly "wipe") when shown. Primaries first -- those hit the board the instant the
// game starts -- then the reveal-only secondaries. Limited concurrency so we don't saturate the link
// or starve the images the board is actively loading. Cheap and idempotent: kept refs so we can drop
// in-flight loads on unmount.
const preloadImgs: HTMLImageElement[] = []
let preloadStarted = false

function preloadImages() {
  if (preloadStarted) {
    return
  }
  preloadStarted = true
  const pairs = cardPairsRef.value
  const primaries = pairs.map(p => p.images[0])
  const secondaries = pairs.flatMap(p => p.images.slice(1))
  const urls = [...primaries, ...secondaries].map(img => imageSrc(img)).filter(Boolean)

  let next = 0
  const loadNext = () => {
    if (next >= urls.length) {
      return
    }
    const img = new Image()
    preloadImgs.push(img)
    img.onload = img.onerror = loadNext // chain the next as each finishes
    img.src = urls[next++]
  }
  for (let c = 0; c < 4; c++) {
    loadNext()
  }
}

// relationship path from the root person: F (father) = blue square, M (mother) = pink square
function relationshipPath(pair: MatchingCardPair) {
  return [...(pair.relationship || '')].map(step => (step === 'F' ? 'f' : 'm'))
}

// the person's given name -- flashed on an image card when it flips up, before the relationship squares
function firstName(pair: MatchingCardPair) {
  return pair.name.trim().split(/\s+/)[0]
}

function setTeamColor(teamId: number, color: string) {
  teamColorsRef.value = teamColorsRef.value.map((c, id) => (id === teamId ? color : c))
}

function setTeamName(teamId: number, name: string) {
  teamNamesRef.value = teamNamesRef.value.map((n, id) => (id === teamId ? name : n))
}

function startGame() {
  sounds.startGame()
  setupDoneRef.value = true
  dealReadyRef.value = false // cards appear after a short pause so the jingle plays first
  lockRef.value = true // hold until spinTurnBar unlocks after the deal animation
  requestAnimationFrame(() => requestAnimationFrame(() => {
    measureAlignment()
    setTimeout(() => {
      dealReadyRef.value = true
      sounds.placeCards()
      requestAnimationFrame(measureAlignment) // remeasure now that cards are in the DOM
      setTimeout(spinTurnBar, dealWaitMs)
    }, 500)
  }))
}

function toggleFullscreen() {
  if (document.fullscreenElement) {
    document.exitFullscreen()
  } else {
    rootRef.value?.requestFullscreen()
  }
}

function onFullscreenChange() {
  isFullscreenRef.value = !!document.fullscreenElement
  requestAnimationFrame(measureAlignment)
}

onMounted(() => {
  document.addEventListener('fullscreenchange', onFullscreenChange)
  window.addEventListener('resize', measureAlignment)
  measureAlignment()
})
onUnmounted(() => {
  document.removeEventListener('fullscreenchange', onFullscreenChange)
  window.removeEventListener('resize', measureAlignment)
  window.removeEventListener('click', onMismatchClick, true)
  window.clearTimeout(peekTimer)
  // stop preloading if the player leaves mid-load
  preloadImgs.forEach((img) => { img.onload = img.onerror = null; img.src = '' })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootRef",
    ref: rootRef,
    class: _normalizeClass(["matching-game", { fullscreen: isFullscreenRef.value }])
  }, [
    (featureEnabledRef.value === undefined || loadingRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(LoadingIndicator)
        ]))
      : (errorRef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: loadDefinition
            }, "Try again")
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h1", null, _toDisplayString(gameTitleRef.value), 1),
                (gameSubtitleRef.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(gameSubtitleRef.value), 1))
                  : _createCommentVNode("", true)
              ]),
              (setupDoneRef.value && !endGameRef.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-link hint-btn",
                    "aria-label": "Hint",
                    disabled: remainingPairCountRef.value < 4,
                    onClick: showHint
                  }, [
                    _createVNode(_unref(ZapIcon))
                  ], 8, _hoisted_7))
                : _createCommentVNode("", true),
              (setupDoneRef.value && !endGameRef.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-link peek-btn",
                    "aria-label": "Peek at all cards",
                    disabled: peekingRef.value || lockRef.value || phaseRef.value !== 'idle',
                    onClick: peek
                  }, [
                    _createVNode(_unref(EyeIcon))
                  ], 8, _hoisted_8))
                : _createCommentVNode("", true),
              (setupDoneRef.value && !endGameRef.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn btn-link skip-btn",
                    "aria-label": "End game",
                    onClick: skipToEnd
                  }, [
                    _createVNode(_unref(SkipForwardIcon))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-link mute-btn",
                "aria-label": _unref(mutedRef) ? 'Unmute' : 'Mute',
                onClick: _cache[0] || (_cache[0] = ($event: any) => (sounds.toggleMute()))
              }, [
                (_unref(mutedRef))
                  ? (_openBlock(), _createBlock(_unref(VolumeXIcon), { key: 0 }))
                  : (_openBlock(), _createBlock(_unref(Volume2Icon), { key: 1 }))
              ], 8, _hoisted_9),
              _createElementVNode("button", {
                class: "btn btn-link fullscreen-btn",
                "aria-label": isFullscreenRef.value ? 'Exit fullscreen' : 'Fullscreen',
                onClick: toggleFullscreen
              }, [
                (isFullscreenRef.value)
                  ? (_openBlock(), _createBlock(_unref(MinimizeIcon), { key: 0 }))
                  : (_openBlock(), _createBlock(_unref(MaximizeIcon), { key: 1 }))
              ], 8, _hoisted_10)
            ]),
            (!setupDoneRef.value)
              ? (_openBlock(), _createBlock(MatchingGameSetup, {
                  key: 0,
                  teams: teamsRef.value,
                  colors: teamColorsRef.value,
                  names: teamNamesRef.value,
                  "first-pair": firstCardPairRef.value,
                  "first-image-src": firstImageSrcRef.value,
                  "onUpdate:color": setTeamColor,
                  "onUpdate:name": setTeamName,
                  onStart: startGame
                }, null, 8, ["teams", "colors", "names", "first-pair", "first-image-src"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", {
                    ref_key: "playAreaRef",
                    ref: playAreaRef,
                    class: _normalizeClass(["play-area", { 'end-game': endGameRef.value }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamsRef.value, (team) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: team.id,
                        class: _normalizeClass(["team-panel", [team.side, endGameRef.value && winnerTeamRef.value !== null && winnerTeamRef.value !== team.id && 'loser']]),
                        style: _normalizeStyle({ paddingTop: endGameRef.value ? undefined : `${alignTopRef.value}px` })
                      }, [
                        _createElementVNode("div", {
                          class: "team-circle team-indicator",
                          style: _normalizeStyle({ background: teamColorsRef.value[team.id] })
                        }, null, 4),
                        _hoisted_11,
                        _createElementVNode("div", _hoisted_12, _toDisplayString(teamNamesRef.value[team.id]), 1),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["team-score", { bump: scoreBumpTeamsRef.value.includes(team.id) }])
                          }, _toDisplayString(team.matches.length), 3),
                          _createVNode(MatchingConfetti, {
                            trigger: team.matches.length,
                            color: teamColorsRef.value[team.id]
                          }, null, 8, ["trigger", "color"])
                        ]),
                        (!endGameRef.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "team-stack",
                              ref_for: true,
                              ref: el => setStackRef(team.id, el)
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team.matches, (pair, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: i,
                                  class: "stack-item",
                                  style: _normalizeStyle({ '--stack-i': i, visibility: reviewModeRef.value && revealPairRef.value?.id === pair.id ? 'hidden' : undefined }),
                                  onClick: ($event: any) => (reviewMatch(pair, $event))
                                }, [
                                  _createVNode(MatchingImageCard, {
                                    src: imageSrc(pair.images[0]),
                                    focal: pair.images[0],
                                    relationship: pair.relationship,
                                    alt: pair.name
                                  }, null, 8, ["src", "focal", "relationship", "alt"])
                                ], 12, _hoisted_14))
                              }), 128))
                            ], 512))
                          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team.matches, (pair, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: i,
                                  class: "pair-unit",
                                  style: _normalizeStyle({ '--pair-size': `${gridCardSizeRef.value * 0.75}px` }),
                                  onClick: ($event: any) => (reviewMatch(pair, $event))
                                }, [
                                  _createElementVNode("div", _hoisted_17, [
                                    _createVNode(MatchingImageCard, {
                                      src: imageSrc(pair.images[0]),
                                      focal: pair.images[0],
                                      relationship: pair.relationship,
                                      alt: pair.name
                                    }, null, 8, ["src", "focal", "relationship", "alt"])
                                  ]),
                                  _createElementVNode("div", _hoisted_18, _toDisplayString(pair.name), 1)
                                ], 12, _hoisted_16))
                              }), 128))
                            ]))
                      ], 6))
                    }), 128)),
                    _createElementVNode("div", _hoisted_19, [
                      (endGameRef.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("button", {
                              class: "btn btn-primary btn-lg",
                              onClick: resetGame
                            }, "Play again")
                          ]))
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("div", {
                        ref_key: "boardRef",
                        ref: boardRef,
                        class: "board-grid",
                        style: _normalizeStyle({ gridTemplateColumns: `auto repeat(${columnCountRef.value}, 1fr)`, '--grid-gap': `${gridGapRef.value}px`, maxWidth: boardMaxWidthRef.value ? `${boardMaxWidthRef.value}px` : undefined })
                      }, [
                        _hoisted_22,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columnLabelsRef.value, (col) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: col,
                            class: "col-label"
                          }, _toDisplayString(col), 1))
                        }), 128)),
                        (dealReadyRef.value)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(rowsRef.value, (row, r) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: r }, [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(r + 1), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (card, ci) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: card.key,
                                    "data-key": card.key,
                                    class: _normalizeClass(["card", { 'is-up': isFaceUp(card), selected: isSelected(card), matched: isMatched(card), collected: collectedKeysRef.value.includes(card.key), hint: hintBlinkingRef.value && hintPairIdsRef.value.includes(card.pairId) }]),
                                    style: _normalizeStyle({ '--deal-i': r * columnCountRef.value + ci, gridColumnStart: cardColumnStart(row, ci), '--nudge-x': `${selectionNudgeRef.value[card.key]?.x ?? 0}px`, '--nudge-y': `${selectionNudgeRef.value[card.key]?.y ?? 0}px` }),
                                    type: "button",
                                    onClick: ($event: any) => (flip(card))
                                  }, [
                                    _createElementVNode("div", _hoisted_25, [
                                      _hoisted_26,
                                      _createElementVNode("div", _hoisted_27, [
                                        (card.face === 'image')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                              _withDirectives(_createElementVNode("img", {
                                                src: imageSrc(card.pair.images[0]),
                                                alt: card.pair.name
                                              }, null, 8, _hoisted_29), [
                                                [_unref(vFocal), card.pair.images[0]]
                                              ])
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                              _createElementVNode("div", _hoisted_31, _toDisplayString(card.pair.name), 1),
                                              _createElementVNode("div", _hoisted_32, [
                                                _createElementVNode("div", _hoisted_33, _toDisplayString(card.pair.text), 1)
                                              ])
                                            ])),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["card-footer", { 'reveal-name': card.face === 'image' }])
                                        }, [
                                          (card.face === 'image')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(firstName(card.pair)), 1))
                                            : _createCommentVNode("", true),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relationshipPath(card.pair), (step, i) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: i,
                                              class: _normalizeClass(["rel-square", step])
                                            }, null, 2))
                                          }), 128))
                                        ], 2)
                                      ])
                                    ])
                                  ], 14, _hoisted_24))
                                }), 128))
                              ], 64))
                            }), 128))
                          : _createCommentVNode("", true)
                      ], 4), [
                        [_vShow, !endGameRef.value]
                      ])
                    ])
                  ], 2),
                  (!endGameRef.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "turn-bar",
                        style: _normalizeStyle({
          top: `${turnBarTopRef.value}px`,
          opacity: turnBarVisibleRef.value ? 1 : 0,
          transition: turnBarTransitionRef.value,
          transform: `translateX(${turnBarXRef.value - (turnBarWidth * uiScaleRef.value) / 2}px)`,
        })
                      }, null, 4))
                    : _createCommentVNode("", true),
                  (revealPairRef.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["reveal-scrim", { visible: revealVisibleRef.value }]),
                          onClick: dismissReveal
                        }, null, 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["reveal-image", { dimmed: focusKeyRef.value && focusKeyRef.value !== 'primary', focused: focusKeyRef.value === 'primary' }]),
                          style: _normalizeStyle({ width: `${imageBoxRef.value.w}px`, height: `${imageBoxRef.value.h}px`, transform: imageTransformRef.value }),
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (focusImage('primary')), ["stop"]))
                        }, [
                          _createVNode(MatchingImageCard, {
                            src: imageSrc(revealImageRef.value),
                            focal: revealFocalRef.value,
                            relationship: revealPairRef.value.relationship,
                            alt: revealPairRef.value.name
                          }, null, 8, ["src", "focal", "relationship", "alt"])
                        ], 6),
                        _createElementVNode("div", {
                          class: _normalizeClass(["reveal-detail", { visible: revealVisibleRef.value, dimmed: focusKeyRef.value }]),
                          style: _normalizeStyle({ width: `${detailBoxRef.value.w}px`, height: `${detailBoxRef.value.h}px`, transform: detailTransformRef.value }),
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (dismissReveal()), ["stop"]))
                        }, [
                          _createVNode(MatchingDetailCard, { pair: revealPairRef.value }, null, 8, ["pair"])
                        ], 6),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(revealSecondaryRef.value, (sec, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i,
                            class: _normalizeClass(["reveal-secondary", { visible: revealVisibleRef.value, dimmed: focusKeyRef.value && focusKeyRef.value !== ('sec-' + i) }]),
                            style: _normalizeStyle({ width: `${sec.dw}px`, height: `${sec.dh}px`, transform: sec.transform }),
                            onClick: _withModifiers(($event: any) => (focusImage('sec-' + i)), ["stop"])
                          }, [
                            _withDirectives(_createElementVNode("img", {
                              src: imageSrc(sec.image),
                              alt: ""
                            }, null, 8, _hoisted_37), [
                              [_unref(vFocal), focusKeyRef.value === ('sec-' + i) ? DEFAULT_FOCAL : sec.image]
                            ])
                          ], 14, _hoisted_36))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
          ], 64))
  ], 2))
}
}

})